import { render, staticRenderFns } from "./newZhe.vue?vue&type=template&id=ba78e07a&scoped=true&"
import script from "./newZhe.vue?vue&type=script&lang=js&"
export * from "./newZhe.vue?vue&type=script&lang=js&"
import style0 from "./newZhe.vue?vue&type=style&index=0&id=ba78e07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba78e07a",
  null
  
)

export default component.exports